import {connect, IConnectProps} from 'globx-react';
import * as React               from 'react';
import {Subject}                from 'rxjs';

import StoreName              from '../../../../State/Shared/Constants/StoreName';
import Playback               from '../../../../State/Stores/Playback/Playback';
import * as TestIds           from '../../../Shared/Constants/TestIds';
import UiEventType            from '../../../Shared/Constants/UiEventType';
import IUiEventsStreamPayload from '../../../Shared/Interfaces/IUiEventsStreamPayload';
import composeTokenList       from '../../Util/composeTokenList';
import renderTestId           from '../../Util/renderTestId';
import * as styles            from '../PlaybackButtons/playbackButtons.css';

import IconRewind from './Assets/IconRewind';

interface IRewindProps extends IConnectProps<Playback> {
    areControlsIdle: boolean;
    uiEvents$: Subject<IUiEventsStreamPayload>;
}

@connect(StoreName.PLAYBACK)
class Rewind extends React.Component<IRewindProps> {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    public shouldComponentUpdate(nextProps: IRewindProps): boolean {
        return nextProps.areControlsIdle !== this.props.areControlsIdle;
    }

    public render(): JSX.Element {
        const testId = composeTokenList([
            TestIds.PLAYER_BUTTON_REWIND,
            [!this.props.areControlsIdle, TestIds.PLAYER_BUTTON_REWIND_VISIBLE]
        ]);

        return (
            <button
                className={styles.playbackButton}
                onClick={this.handleClick}
                data-test-id={renderTestId(testId)}
            >
                <IconRewind/>
            </button>
        );
    }

    private handleClick(): void {
        this.props.uiEvents$.next({
            type: UiEventType.REWIND_TAP
        });
    }
}

export default Rewind;